import { render } from "./ManufacturerLoginView.vue?vue&type=template&id=fcdce702"
import script from "./ManufacturerLoginView.vue?vue&type=script&lang=js"
export * from "./ManufacturerLoginView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/kinetics/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__